import React, { useState } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import api from '../../../utils/api';

export const DiscardModal = ({ show, onHide, roomId,initiatedFolios,getDraftGoalData }) => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [hasError, setHasError] = useState(false); // Error state to manage modal behavior


  const ids = initiatedFolios.map(folio => folio._id).join(',');

  const onSubmit = async (data) => {
    if (isLoading) return; // Prevent multiple submissions

    setIsLoading(true); // Set loading state to true
    setHasError(false); // Reset error state before attempting submission
    try {
      const response = await api.post(
        `advisor/cancel_event`,
        {
            ids:ids,
          client_id: roomId,
          remarks: data.remark,
        }
      );
      getDraftGoalData()
      console.log(response.data);
      toast.success('Event has been discarded successfully.');
      onHide(); // Close the modal on success
      reset(); // Reset the form fields
    } catch (error) {
      console.error('Error fetching data:', error);
      setHasError(true); // Set error state if the request fails
      if (error.response) {
        toast.error(`Error: ${error.response.data.message || 'An error occurred'}`);
      } else {
        toast.error('An unexpected error occurred.');
      }
    } finally {
      setIsLoading(false); // Reset loading state after request
    }
  };

  const handleClose = () => {
    reset(); // Reset the form when closing or clicking "No"
    onHide(); // Close the modal
  };

  return (
    <Modal  show={show} onHide={handleClose} className="custom-sm-modal" centered size='md'
    // dialogClassName="modal-90w"
    // aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton  className='pb-0' style={{ backgroundColor: "#fff", border: 'none' }}>
        <Modal.Title >Are you sure?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fw-semibold clrgreen text-center w-100 mx-auto ">
          This will discard the Goal Event! Proceed?
        </p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={12} className="">
              <Form.Group controlId="remark">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  type="text"
                //   rows={3}
                  placeholder="Enter remarks"
                  {...register("remark", {
                    required: "Remark is required",
                    minLength: {
                      value: 5,
                      message: "Remark must be at least 5 characters",
                    },
                  })}
                  aria-invalid={errors.remark ? "true" : "false"}
                />
                {errors.remark && (
                  <p className="error text-danger">{errors.remark.message}</p>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Modal.Footer className="border-0 mx-auto w-100">
            <button
              type="submit"
              className="lrgbutton text-white w-100 text-uppercase"
              aria-label="Submit remark"
              disabled={isLoading} // Disable the button during loading
            >
              {isLoading ? 'Wait...' : 'OK'}
            </button>
            {/* <button
              type="button"
              className="lrgbutton text-white bg-secondary w-25 text-uppercase"
              onClick={handleClose} // Reset the form and close modal
              aria-label="Cancel and close"
            >
              No
            </button> */}
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
